import React from 'react';
import PropTypes from 'prop-types';
//import './ReviewQuoteSpinnerComponent.scss';

export default class ReviewQuoteSpinnerComponent extends React.PureComponent {
    static propTypes = {
        show: PropTypes.bool.isRequired
    };

    render() {
        const { show } = this.props;

        return (<div>
            <div className={`overlay ${show? "show" : ""}`}></div>
            <div className={`spanner ${show? "show" : ""}`}>
                <div className="loader"></div>
                <h3>Updating prices, please wait...</h3>
            </div>
        </div>
        );
    }
}
